import React from 'react';
import styled from 'styled-components';
import { Row, Text, theme } from '@dls/web';
import { ArrowLeft as BackArrowIcon } from '@dls/assets/icons';
import { Clear as ClearIcon } from '@dls/assets/icons';

import useTranslation from '../../hooks/useTranslation';

const StyledPanel = styled.div``;
const PanelBody = styled.div`
  padding: 16px 32px 64px;
  margin-top: 24px;
`;

const BackToMenu = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 24px;
`;

type PanelProps = {
  onClose: () => void;
  onClear: () => void;
  children: any;
  isRootPage?: boolean;
};

export const Panel = ({
  onClose,
  onClear,
  children,
  isRootPage = false
}: PanelProps) => {
  const { t } = useTranslation();

  return (
    <StyledPanel>
      <Row reverse between="xs">
        <ClearIcon
          width="50px"
          height="50px"
          color={theme.main.colours.tertiary.base}
          onClick={onClose}
        />

        {!isRootPage && (
          <BackToMenu onClick={onClear}>
            <BackArrowIcon width="24px" height="24px" />
            <Text type="sectionTitle" style={{ marginLeft: '16px' }}>
              {t('PANEL_GO_BACK')}
            </Text>
          </BackToMenu>
        )}
      </Row>
      <PanelBody>{children}</PanelBody>
    </StyledPanel>
  );
};
